import Vue from 'vue';

const success = (data, resolve) => {
  resolve(data);
};

const failed = (errors, reject) => {
  reject(errors);
};

export default () => {
  const p = new Promise((resolve, reject) => {
    Vue.$http
    .get('auth/resend-confirm')
    .then((response) => {
      success(response.data, resolve);
    })
    .catch((error) => {
      failed(error.response.data, reject);
    });
  });
  return p;
};



// WEBPACK FOOTER //
// ./src/app/services/auth/resendConfirmation.js